

$("#rental-type.fancy-input, #packages #boxes .line").on("change", "input", function () {
  $("form").trigger("submit");
});

if ($(".colored-input").length) {
  let parent = $(".colored-input").eq(0).data("parent") || ".line";
  $(parent).on("click", "label", function (e) {
    let $this = $(this);
    let toggleClass =
      $(".colored-input").eq(0).data("toggle-class") || "active";
    $(parent).removeClass(toggleClass);
    $this.parents(parent).eq(0).addClass(toggleClass);
  });
}

if ($("#combo").length && $('#combo-form-available input, #combo-form-selected input[type=checkbox]').length) {
  $('#combo-form-available input, #combo-form-selected input[type=checkbox]').on('change', function () {
    let currentArray = [];
    let current = '';
    $('#combo-form-selected input').each(function (index, item) {
      if($(item).prop('checked') || $(item).prop('type') == 'hidden') {
        currentArray.push($(item).val());
      }
    });
    $('#combo-form-available input').each(function (index, item) {
      if($(item).prop('checked')) {
        currentArray.push($(item).val());
      }
    });
    currentArray.sort();
    current = currentArray.join('_');
    $('#selection .color-box').addClass('hidden');
    $('#selection .color-box').find('input[type=radio]').prop('checked', false);
    if($('#selection').find('#'+current).length !== 0) {
      $('#selection').find('#'+current).removeClass('hidden');
      $('#selection').find('#'+current + ' input[type=radio]').prop('checked', true);
    }
  });
  $('#combo-form-available input:first-child').trigger('change');
}

if ($("#prices").length) {
  /**
   * Disables or enables input fields of a unit row.
   *
   * @param {jQuery} $row
   * @param {boolean} disable
   * @return {void}
   */
  const toggleUnitRowInputs = ($row, disable) => {
    $row.find(".count input").prop("readonly", disable);
    $row.find(".price input").prop("readonly", disable);

    if (!["SINGLE", "DOUBLE"].includes($row.find("th").data("type"))) {
      $row.find(".capacity input").prop("readonly", disable);
    }

    window.initFloatingLabels();
  };

  $('input[type="checkbox"][id$="_enabled"]').each(function (idx, item) {
    const isChecked = $(item).is(":checked");
    const $row = $(item).parents("tr");

    toggleUnitRowInputs($row, !isChecked);
  });

  $('input[type="checkbox"][id$="_enabled"]').on("change", function () {
    const isChecked = $(this).is(":checked");
    const $row = $(this).parents("tr");

    toggleUnitRowInputs($row, !isChecked);
  });

  $('#prices, #price-options').on("focus", 'input[type=text], input[type=number]', function () {
    let $this = $(this);
    if (parseInt($this.val()) == 0 && $(this).prop("readonly") == false) {
      $this.val("");
    }
  }).on("blur", 'input[type=text], input[type=number]', function () {
    let $this = $(this);
    if ($this.val() == "") {
      if ($this.prop("type") == "number") {
        $this.val(0);
      } else {
        $this.val("0,00");
      }
    }
  });

  //set aggregated price
  $("#prices tbody").on("change", "input", function () {
    var line = $(this).parents("tr");
    var count = line.find(".count input").val() || 1;

    //set minimum price if capacity is set
    if (count >= 1) {
      line.find(".price input").attr("min", 1);
      line.find(".price input").attr("required", "required");
      if (line.find(".price input").val() == "0,00") {
        line.find(".price input").val("");
      }
      line.find(".capacity input").attr("min", 1);
      line.find(".capacity input").attr("required", "required");
    } else {
      line.find(".price input").attr("min", 0);
      line.find(".price input").removeAttr("required");
      if (line.find(".price input").val() == "") {
        line.find(".price input").val("0,00");
      }
      line.find(".capacity input").attr("min", 0);
      line.find(".capacity input").removeAttr("required");
    }

    var price = line.find(".price input").val() || 0;
    if (price != "") {
      price = price.replace(",", ".");
    }

    if (price > 0 && count == 0) {
      line.find(".count input").attr("min", 1);
      line.find(".count input").attr("required", "required");
    } else {
      line.find(".count input").attr("min", 0);
      line.find(".count input").removeAttr("required");
    }

    if (line.find(".count input").val() < count && line.find(".count input").prop("readonly") == false) {
      line.find(".count input").val(count);
    } else if (line.find(".count input").prop("readonly")) {
      line.find(".count input").val(0);
      line.find(".price input").val("0,00");
      if(parseInt(line.find(".price input").val()) > 0) {
        line.find(".price input").val(0);
      }
      if(line.find(".capacity input").val() == "") {
        line.find(".capacity input").val(0);
      }
    }

    var type = line.find("th").data("type");
    var capacity = line.find(".capacity input").val() || 1;
    var per_person = Math.round(parseFloat(price) / capacity);
    var label =
      global.Translator.trans(
        "units.type." + (count > 1 ? "plural." : "singular.") + type,
        {},
        "js"
      ) +
      " " +
      global.Translator.transChoice(
        "units.taglines.price",
        parseInt(capacity),
        // parseInt(capacity) > 1 && parseInt(price) > 1 ? parseInt(capacity) : parseInt(price) > 1 && type != 'SINGLE' ? parseInt(capacity) : 0,
        // parseInt(capacity) > 1 && parseInt(price) > 0 ? parseInt(capacity) : parseInt(price) > 0 && type != 'SINGLE' ? parseInt(price) : 1,
        {
          price: "" + per_person,
        },
        "js"
      );
    if (isNaN(per_person) || !isFinite(per_person) || per_person < 0) {
      per_person = 0;
    }

    line.next().find(".count").text(count);
    line.next().find(".final .label").text(label);
    // line.next().find('.amount').text(amountToHuman(per_person))
    line.next().find(".amount").text("");
    line.next().find("input[type=hidden]").val(per_person);
    per_person > 0 && count > 0
      ? line.next().find(".final").removeClass("hidden")
      : line.next().find(".final").addClass("hidden");
    var min = null;
    $("#prices tbody input[type=hidden]").each(function (idx, item) {
      var item_per_person = parseFloat($(item).val());

      if (
        min == null ||
        min == 0 ||
        (typeof min !== "undefined" &&
          item_per_person != 0 &&
          item_per_person < min)
      ) {
        min = item_per_person;
        var human_per_person = amountToHuman(item_per_person);
        $("#prices table tfoot tr:last-child td .amount").data(
          "amount",
          item_per_person
        );
        $("#prices table tfoot tr:last-child td .amount").text(
          human_per_person
        );
        item_per_person > 0
          ? $("#prices table tfoot tr:last-child td .final").removeClass(
              "hidden"
            )
          : $("#prices table tfoot tr:last-child td .final").addClass("hidden");
      }
    });
  });

  $("#prices table .capacity input").each(function (index, item) {
    $(item).trigger("change");
  });
}
